import { shape, arrayOf, string, bool, number } from 'prop-types';

export const CartItemPropType = shape({
  item_id: string,
  id: string,
  product_id: string,
  code: string,
  title: string,
  min_quantity: number,
  quantity: number,
  price: number,
  promo_price: number,
  discount: number,
  green_stamp_value: number,
  total_price: number,
  currency: string,
  ron_price: number,
  ron_total_price: number,
  ron_promo_price: number,
  main_product: bool,
  picture_url: string,
  type: string,
  cash_on_delivery_value: number,
  vat_value: number,
  vat_percent: number,
  promotion: shape({
    promotion_id: string,
    type: string,
    description: string
  }),
  parent: string
});

const CartPropType = shape({
  items: arrayOf(CartItemPropType),
  total: number
});

export default CartPropType;
